import moment from "moment";
import Services from "../../services";
import Helpers from "../../services/helpers";

const strippedMoneyFormat = (val) => Helpers.formatMoney(val).replace(/,/g, "");

export const TYPES = {
  PLAYER_LEADERBOARD: "PLAYER_LEADERBOARD",
  CARD_LEADERBOARD: "CARD_LEADERBOARD",
  AUCTION: "AUCTION",
  MY_COLLECTION: "MY_COLLECTION",
  MY_COLLECTION_SOLD: "MY_COLLECTION_SOLD",
  API_CALL_LOGGING_FIELDS: "API_CALL_LOGGING_FIELDS",
  MY_COLLECTION_SEALED_WAX: "MY_COLLECTION_SEALED_WAX",
  MY_COLLECTION_SEALED_WAX_SOLD: "MY_COLLECTION_SEALED_WAX_SOLD",
  MY_COLLECTION_IMPORT_REJECTED: "MY_COLLECTION_IMPORT_REJECTED",

  ADMIN_PLAYER_FIELDS: "ADMIN_PLAYER_FIELDS",
  ADMIN_SET_FIELDS: "ADMIN_SET_FIELDS",
  ADMIN_SET_VARIATION_FIELDS: "ADMIN_SET_VARIATION_FIELDS",
  ADMIN_GRADE_FIELDS: "ADMIN_GRADE_FIELDS",
  ADMIN_VARIATION_FIELDS: "ADMIN_VARIATION_FIELDS",
  ADMIN_CARD_FIELDS: "ADMIN_CARD_FIELDS",
  ADMIN_CARD_RESULTS_FIELDS: "ADMIN_CARD_RESULTS_FIELDS",
};

export const PLAYER_LEADERBOARD_FIELDS = [
  {
    key: "player",
    label: "Player",
  },
  {
    key: "cards",
    label: "Number of Cards",
    formatter: (val) => val.length,
  },
  {
    key: "percent_change",
    label: "Percent Change",
  },
  {
    key: "total",
    label: "Total Value of Sales",
    formatter: strippedMoneyFormat,
  },
  {
    key: "avg",
    label: "Average Sale",
    formatter: strippedMoneyFormat,
  },
  {
    key: "count",
    label: "Total Number of Sales",
  },
  {
    key: "min",
    label: "Minimum Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "max",
    label: "Maximum Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "count",
    label: "Sales Volume",
  },
];

export const CARD_LEADERBOARD_FIELDS = [
  {
    key: "player",
    label: "Player",
  },
  {
    key: "card",
    label: "Card",
  },
  {
    key: "change",
    label: "Change",
    formatter: strippedMoneyFormat,
  },
  {
    key: "percent_change",
    label: "Percent Change",
  },
  {
    key: "startAvg",
    label: "Start Avg",
    formatter: strippedMoneyFormat,
  },
  {
    key: "endAvg",
    label: "End Avg",
    formatter: strippedMoneyFormat,
  },
  {
    key: "total",
    label: "Total of Sales",
    formatter: strippedMoneyFormat,
  },
  {
    key: "min",
    label: "Minimum Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "max",
    label: "Maximum Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "count",
    label: "Sales Volume",
  },
];

export const AUCTION_FIELDS = [
  {
    key: "title",
    label: "Auction Title",
  },
  {
    key: "end_time",
    label: "Auction End Time",
    formatter: Helpers.formatDateWithTime,
  },
  {
    key: "auction_type",
    label: "Auction Type",
    formatter: (auctionType) => (auctionType ? auctionType : "Unavailable"),
  },
  {
    key: "number_of_bids",
    label: "Number of Bids",
  },
  {
    key: "selling_price",
    label: "Selling Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "offer_price",
    label: "Offer Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "buyer_feedback_rating",
    label: "Buyer Feedback Rating",
  },
  {
    key: "seller_name",
    label: "Seller Name",
  },
  {
    key: "location",
    label: "Location",
    formatter: (location) => location.replace(/,/g, " "),
  },
];

export const API_CALL_LOGGING_FIELDS = [
  {
    key: "name",
    label: "Name",
  },
  {
    key: "lastDay",
    label: "Last 24 hours",
  },
  {
    key: "last7Days",
    label: "Last 7 days",
  },
  {
    key: "last14Days",
    label: "Last 14 days",
  },
  {
    key: "last30Days",
    label: "Last 30 days",
  },
];

export const collectionCsvMapper = (data) => {
  return data
    .map(({ children, ...record }) => [
      record,
      ...children.map((child) => ({ ...child, card_title: record.card_title })),
    ])
    .flat();
};

export const MY_COLLECTION_FIELDS = [
  {
    key: "card_title",
    label: "Card",
  },
  {
    key: "parent_record",
    label: "Type",
    formatter: (val) => (val ? "Header" : "Transaction"),
  },
  {
    key: "date_purchased",
    label: "Date Purchased",
    formatter: (val) => (val === "Multiple" ? val : val ? Helpers.formatDateWithTime(val, false) : ""),
  },
  {
    key: "quantity",
    label: "Qty Owned",
  },
  {
    key: "purchase_price_per_card",
    label: "Avg Paid",
    formatter: strippedMoneyFormat,
  },
  {
    key: "purchase_price",
    label: "Total Paid",
    formatter: strippedMoneyFormat,
  },
  {
    key: "lastAverageSale",
    label: "Last Avg Sale",
    formatter: strippedMoneyFormat,
  },
  {
    key: "total_end_value",
    label: "Total Value",
    formatter: strippedMoneyFormat,
  },
  {
    key: "profit_or_loss",
    label: "Net Value",
    formatter: strippedMoneyFormat,
  },
  {
    key: "isCustomCard",
    label: "Card Type",
    formatter: (val) => (val ? "Manual Card" : "System Card"),
  },
  {
    key: "note",
    label: "Notes",
    formatter: (val) => val || "",
  },
];

export const MY_COLLECTION_IMPORT_REJECTED_FIELDS = [
  {
    key: "PlayerName",
    label: "Player Name",
  },
  {
    key: "Year",
    label: "Year",
  },
  {
    key: "Set",
    label: "Set",
  },
  {
    key: "Variation",
    label: "Variation",
  },
  {
    key: "Grade",
    label: "Grade",
  },
  {
    key: "Quantity",
    label: "Quantity",
  },
  {
    key: "DatePurchased",
    label: "Date Purchased",
  },
  {
    key: "PurchasePricePerCard",
    label: "Purchase Price Per Card",
  },
];

export const MY_COLLECTION_SOLD_FIELDS = [
  {
    key: "card_title",
    label: "Card",
  },
  {
    key: "parent_record",
    label: "Type",
    formatter: (val) => (val ? "Header" : "Transaction"),
  },
  {
    key: "datePurchased",
    label: "Purchase Date",
    formatter: (val) => (val === "Multiple" ? val : val ? Helpers.formatDateWithTime(val, false) : ""),
  },
  {
    key: "dateSold",
    label: "Date Sold",
    formatter: (val) => (val === "Multiple" ? val : val ? Helpers.formatDateWithTime(val, false) : ""),
  },
  {
    key: "avgCost",
    label: "Avg Cost",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalCost",
    label: "Total Paid",
    formatter: strippedMoneyFormat,
  },
  {
    key: "soldQuantity",
    label: "Sold Qty",
  },
  {
    key: "avgSalePrice",
    label: "Avg Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalSalesPrice",
    label: "Total Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalFees",
    label: "Total Fees",
    formatter: strippedMoneyFormat,
  },
  {
    key: "profitOrLoss",
    label: "Net Value",
    formatter: strippedMoneyFormat,
  },
  {
    key: "isCustomCard",
    label: "Card Type",
    formatter: (val) => (val ? "Manual Card" : "System Card"),
  },
  {
    key: "note",
    label: "Notes",
    formatter: (val) => val || "",
  },
];

export const MY_COLLECTION_SEALED_WAX_FIELDS = [
  {
    key: "card_title",
    label: "Pack Title",
  },
  {
    key: "parent_record",
    label: "Type",
    formatter: (val) => (val ? "Header" : "Transaction"),
  },
  {
    key: "date_purchased",
    label: "Date Purchased",
    formatter: (val) => (val === "Multiple" ? val : val ? Helpers.formatDateWithTime(val, false) : ""),
  },
  {
    key: "quantity",
    label: "Qty Owned",
  },
  {
    key: "purchase_price_per_card",
    label: "Avg Paid",
    formatter: strippedMoneyFormat,
  },
  {
    key: "purchase_price",
    label: "Total Paid",
    formatter: strippedMoneyFormat,
  },
];

export const MY_COLLECTION_SEALED_WAX_SOLD_FIELDS = [
  {
    key: "card_title",
    label: "Card",
  },
  {
    key: "parent_record",
    label: "Type",
    formatter: (val) => (val ? "Header" : "Transaction"),
  },
  {
    key: "dateSold",
    label: "Date Sold",
    formatter: (val) => (val === "Multiple" ? val : val ? Helpers.formatDateWithTime(val, false) : ""),
  },
  {
    key: "avgCost",
    label: "Avg Cost",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalCost",
    label: "Total Paid",
    formatter: strippedMoneyFormat,
  },
  {
    key: "soldQuantity",
    label: "Sold Qty",
  },
  {
    key: "avgSalePrice",
    label: "Avg Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalSalesPrice",
    label: "Total Sale Price",
    formatter: strippedMoneyFormat,
  },
  {
    key: "totalFees",
    label: "Total Fees",
    formatter: strippedMoneyFormat,
  },
  {
    key: "profitOrLoss",
    label: "Net Value",
    formatter: strippedMoneyFormat,
  },
  {
    key: "isCustomCard",
    label: "Card Type",
    formatter: (val) => (val ? "Manual Card" : "System Card"),
  },
];

export const ADMIN_PLAYER_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "name",
    label: "PLAYER NAME",
  },
  {
    key: "sport.name",
    label: "SPORT",
  },
  {
    key: "alias",
    label: "ALIAS",
    formatter: (val) => val || "",
  },
  {
    key: "rookie_years",
    label: "ROOKIE YEARS",
    formatter: (val) => val.join(","),
  },
  {
    key: "query",
    label: "QUERY COMPONENT",
    formatter: (val) => val || "",
  },
];

export const ADMIN_SET_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "year",
    label: "SET YEAR",
  },
  {
    key: "name",
    label: "SET NAME",
  },
  {
    key: "sport.name",
    label: "SET SPORT",
  },
  {
    key: "query",
    label: "QUERY COMPONENT",
    formatter: (val) => (val ? val.replace(/(\t|\n|\r)/g, " ") : ""),
  },
  {
    key: "wax_query",
    label: "WAX QUERY COMPONENT",
    formatter: (val) => (val ? val.replace(/(\t|\n|\r)/g, " ") : ""),
  },
  {
    key: "frequency_tier",
    label: "FREQUENCY TIER",
  },
];

export const ADMIN_VARIATION_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "name",
    label: "VARIATION NAME",
  },
];

export const ADMIN_SET_VARIATION_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "card_set.year",
    label: "SET YEAR",
  },
  {
    key: "card_set.name",
    label: "SET NAME",
  },
  {
    key: "card_set.sport.name",
    label: "SET SPORT",
  },
  {
    key: "variation.name",
    label: "VARIATION NAME",
  },
  {
    key: "print_run",
    label: "PRINT RUN",
    formatter: (val) => val || "",
  },
  {
    key: "print_run_value",
    label: "PRINT RUN VALUE",
    formatter: (val) => val || null,
  },
  {
    key: "pack_odds",
    label: "PACK ODDS",
    formatter: (val) => val || "",
  },
  {
    key: "variation_type",
    label: "VARIATION TYPE",
    formatter: (val) => val || "Other",
  },
  {
    key: "query",
    label: "QUERY COMPONENT",
    formatter: (val) => val || "",
  },
];

export const ADMIN_GRADE_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "name",
    label: "GRADE NAME",
  },
  {
    key: "query",
    label: "QUERY COMPONENT",
  },
];

export const ADMIN_CARD_FIELDS = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "player_name",
    label: "PLAYER NAME",
  },
  {
    key: "player_id",
    label: "PLAYER COMPONENT",
    formatter: (val) => (val ? 1 : 0),
  },
  {
    key: "card_set_year",
    label: "SET YEAR",
  },
  {
    key: "card_set_name",
    label: "SET NAME",
  },
  {
    key: "sport_name",
    label: "SET SPORT",
  },
  {
    key: "card_set_id",
    label: "SET COMPONENT",
    formatter: (val) => (val ? 1 : 0),
  },
  {
    key: "variation_name",
    label: "VARIATION NAME",
  },
  {
    key: "print_run",
    label: "PRINT RUN",
    formatter: (val) => val || "",
  },
  {
    key: "print_run_value",
    label: "PRINT RUN VALUE",
    formatter: (val) => val || "",
  },
  {
    key: "set_variation_id",
    label: "VARIATION COMPONENT",
    formatter: (val) => (val ? 1 : 0),
  },
  {
    key: "grade_name",
    label: "GRADE NAME",
  },
  {
    key: "grade_id",
    label: "GRADE COMPONENT",
    formatter: (val) => (val ? 1 : 0),
  },
  {
    key: "specific_qualifier",
    label: "SPECIFIC QUALIFIER",
    formatter: (val) => val || (val === null ? "null" : ""),
  },
  {
    key: "card_number",
    label: "CARD NUMBER",
    formatter: (val) => val || "",
  },
  {
    key: "flex",
    label: "FLEX",
    formatter: (val) => (val ? val.replace(/(\t|\n|\r)/g, " ") : ""),
  },
  {
    key: "frequency_tier",
    label: "FREQUENCY TIER",
  },
  {
    key: "active_frequency_tier",
    label: "ACTIVE LISTINGS FREQUENCY TIER",
  },
  {
    key: "active_slot",
    label: "ACTIVE LISTING SLOT",
  },
];

export const cardsCsvMapper = async (filters) => {
  const data = await Services.getCardsCsv(filters);
  return data;
};

export const ADMIN_CARD_RESULTS_FIELDS = [
  {
    key: "title",
    label: "AUCTION TITLE",
  },
  {
    key: "end_time",
    label: "AUCTION DATE",
    formatter: (val) => moment(val).format("YYYY/MM/DD hh:mm"),
  },
  {
    key: "selling_price",
    label: "AUCTION PRICE",
  },
  {
    key: "source",
    label: "AUCTION SOURCE",
  },
  {
    key: "listing_type",
    label: "SALE TYPE",
  },
  {
    key: "status",
    label: "STATUS",
  },
  {
    key: "card_title",
    label: "CARD TITLE",
    formatter: (val) => val || "",
  },
];
